export enum DeviceLocalization {
	CZ = "CZ",
	SK = "SK",
}
